define("shared/components/shared/credentials/tiktok-refresh-mismatch", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@cancel}} @primaryClass="o--modalBg u--p__0" as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header class="u--p__b__xs">
        <p>
          <b>{{t "tiktok.username_mismatch.title"}}</b>
        </p>
      </modal.card-header>
  
      <modal.card-body>
        <div class="u--m__b__md">
          {{html-safe (t "tiktok.username_mismatch.body")}}
        </div>
      </modal.card-body>
  
      <modal.card-footer>
        <div class="u--row">
          <div class="u--col__12">
            <Shared::Ui::Button
              @class="o--btn u--float--left"
              @onClick={{@cancel}}
              @text={{t "shared_words.cancel"}}
              @variant="outline"
            />
  
            <Shared::Ui::Button
              @class="u--float--right"
              @onClick={{@close}}
              @text={{t "tiktok.username_mismatch.button"}}
              @variant="primary"
              data-test-id="tiktok-mismatch-close-button"
            />
          </div>
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "iG8YZEQ0",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@primaryClass\"],[[30,1],\"o--modalBg u--p__0\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"u--p__b__xs\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[10,\"b\"],[12],[1,[28,[35,1],[\"tiktok.username_mismatch.title\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--m__b__md\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[[28,[37,1],[\"tiktok.username_mismatch.body\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n          \"],[8,[39,3],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"o--btn u--float--left\",[30,1],[28,[37,1],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n\\n          \"],[8,[39,3],[[24,\"data-test-id\",\"tiktok-mismatch-close-button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--float--right\",[30,3],[28,[37,1],[\"tiktok.username_mismatch.button\"],null],\"primary\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@cancel\",\"modal\",\"@close\"],false,[\"shared/modal\",\"t\",\"html-safe\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/credentials/tiktok-refresh-mismatch.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});